export enum ECookiesNames {
  CENTRIFUGE_TOKEN = 'centrifugeToken',
  CENTRIFUGE_TOKEN_EXPIRY = 'centrifugeTokenExpiry',
  SESSION_ID = 'sessionId',
}
